// Categorical palette for multi-series charts, assigned by index in this
// fixed order. The order interleaves hues so adjacent entries remain
// distinguishable under color-vision deficiencies (adjacent-pair CVD
// deltas validated in OKLab against the light surface).
export const CHART_COLORS = [
    '#832BFB', // violet (brand primary)
    '#00C9A7', // teal (legacy training-report chart color, not brand)
    '#4B68FF', // blue (brand secondary)
    '#F59E0B', // amber
    '#E5484D', // red
    '#0891B2', // cyan
    '#DB2777', // pink
    '#65A30D', // olive
    '#6366F1', // indigo
    '#B45309', // brown
    '#C026D3', // magenta
    '#059669', // green
]

// Past the palette the hues repeat (the 13th series wears the 1st color);
// the legend and hover tooltip carry identity from there, the same way
// run-heavy tools like TensorBoard handle palette overflow.
export const chartColor = (index) => CHART_COLORS[index % CHART_COLORS.length]
